import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";

export default function NetworkDiagram() {
	const nodeData = [
		// Central hub
		{
			name: "CoreHub",
			x: 200,
			y: 140,
			itemStyle: { color: "#3b82f6", borderColor: "#60a5fa", borderWidth: 3 },
			symbolSize: 25,
		},

		// Layer 1 - 3 Router nodes connected to hub
		{
			name: "Router-1",
			x: 380,
			y: 80,
			itemStyle: { color: "#0d6efd" },
			symbolSize: 18,
		},
		{
			name: "Router-2",
			x: 380,
			y: 200,
			itemStyle: { color: "#0d6efd" },
			symbolSize: 18,
		},
		{
			name: "Router-3",
			x: 20,
			y: 140,
			itemStyle: { color: "#0d6efd" },
			symbolSize: 18,
		},

		// Layer 2 - Child nodes under Router-1 (8 nodes) - colored green
		{
			name: "Device-1-1",
			x: 420,
			y: 30,
			itemStyle: { color: "#50cd89" },
			symbolSize: 13,
		},
		{
			name: "Device-1-2",
			x: 450,
			y: 45,
			itemStyle: { color: "#50cd89" },
			symbolSize: 13,
		},
		{
			name: "Device-1-3",
			x: 470,
			y: 70,
			itemStyle: { color: "#50cd89" },
			symbolSize: 13,
		},
		{
			name: "Device-1-4",
			x: 480,
			y: 105,
			itemStyle: { color: "#50cd89" },
			symbolSize: 13,
		},
		{
			name: "Device-1-5",
			x: 470,
			y: 95,
			itemStyle: { color: "#50cd89" },
			symbolSize: 13,
		},
		{
			name: "Device-1-6",
			x: 450,
			y: 120,
			itemStyle: { color: "#50cd89" },
			symbolSize: 13,
		},
		{
			name: "Device-1-7",
			x: 420,
			y: 130,
			itemStyle: { color: "#50cd89" },
			symbolSize: 13,
		},
		{
			name: "Device-1-8",
			x: 400,
			y: 110,
			itemStyle: { color: "#50cd89" },
			symbolSize: 13,
		},

		// Layer 2 - Child nodes under Router-2 (8 nodes) - colored yellow
		{
			name: "Device-2-1",
			x: 420,
			y: 160,
			itemStyle: { color: "#ffc107" },
			symbolSize: 13,
		},
		{
			name: "Device-2-2",
			x: 450,
			y: 175,
			itemStyle: { color: "#ffc107" },
			symbolSize: 13,
		},
		{
			name: "Device-2-3",
			x: 470,
			y: 200,
			itemStyle: { color: "#ffc107" },
			symbolSize: 13,
		},
		{
			name: "Device-2-4",
			x: 480,
			y: 235,
			itemStyle: { color: "#ffc107" },
			symbolSize: 13,
		},
		{
			name: "Device-2-5",
			x: 470,
			y: 225,
			itemStyle: { color: "#ffc107" },
			symbolSize: 13,
		},
		{
			name: "Device-2-6",
			x: 450,
			y: 250,
			itemStyle: { color: "#ffc107" },
			symbolSize: 13,
		},
		{
			name: "Device-2-7",
			x: 420,
			y: 260,
			itemStyle: { color: "#ffc107" },
			symbolSize: 13,
		},
		{
			name: "Device-2-8",
			x: 400,
			y: 240,
			itemStyle: { color: "#ffc107" },
			symbolSize: 13,
		},

		// Layer 2 - Child nodes under Router-3 (7 nodes) - colored purple
		{
			name: "Device-3-1",
			x: -50,
			y: 80,
			itemStyle: { color: "#7239ea" },
			symbolSize: 13,
		},
		{
			name: "Device-3-2",
			x: -80,
			y: 100,
			itemStyle: { color: "#7239ea" },
			symbolSize: 13,
		},
		{
			name: "Device-3-3",
			x: -110,
			y: 140,
			itemStyle: { color: "#7239ea" },
			symbolSize: 13,
		},
		{
			name: "Device-3-4",
			x: -120,
			y: 180,
			itemStyle: { color: "#7239ea" },
			symbolSize: 13,
		},
		{
			name: "Device-3-5",
			x: -100,
			y: 200,
			itemStyle: { color: "#7239ea" },
			symbolSize: 13,
		},
		{
			name: "Device-3-6",
			x: -70,
			y: 210,
			itemStyle: { color: "#7239ea" },
			symbolSize: 13,
		},
		{
			name: "Device-3-7",
			x: -40,
			y: 190,
			itemStyle: { color: "#7239ea" },
			symbolSize: 13,
		},
	];

	const linkData = [
		// Core hub to routers (3 main connections)
		{ source: "CoreHub", target: "Router-1" },
		{ source: "CoreHub", target: "Router-2" },
		{ source: "CoreHub", target: "Router-3" },

		// Router-1 to its child devices (8 devices)
		{ source: "Router-1", target: "Device-1-1" },
		{ source: "Router-1", target: "Device-1-2" },
		{ source: "Router-1", target: "Device-1-3" },
		{ source: "Router-1", target: "Device-1-4" },
		{ source: "Router-1", target: "Device-1-5" },
		{ source: "Router-1", target: "Device-1-6" },
		{ source: "Router-1", target: "Device-1-7" },
		{ source: "Router-1", target: "Device-1-8" },

		// Interconnections between Router-1's child devices
		{ source: "Device-1-1", target: "Device-1-2" },
		{ source: "Device-1-2", target: "Device-1-3" },
		{ source: "Device-1-3", target: "Device-1-4" },
		{ source: "Device-1-4", target: "Device-1-5" },
		{ source: "Device-1-5", target: "Device-1-6" },
		{ source: "Device-1-6", target: "Device-1-7" },
		{ source: "Device-1-7", target: "Device-1-8" },
		{ source: "Device-1-8", target: "Device-1-1" },
		{ source: "Device-1-1", target: "Device-1-3" },
		{ source: "Device-1-3", target: "Device-1-6" },
		{ source: "Device-1-5", target: "Device-1-8" },

		// Router-2 to its child devices (8 devices)
		{ source: "Router-2", target: "Device-2-1" },
		{ source: "Router-2", target: "Device-2-2" },
		{ source: "Router-2", target: "Device-2-3" },
		{ source: "Router-2", target: "Device-2-4" },
		{ source: "Router-2", target: "Device-2-5" },
		{ source: "Router-2", target: "Device-2-6" },
		{ source: "Router-2", target: "Device-2-7" },
		{ source: "Router-2", target: "Device-2-8" },

		// Interconnections between Router-2's child devices
		{ source: "Device-2-1", target: "Device-2-2" },
		{ source: "Device-2-2", target: "Device-2-3" },
		{ source: "Device-2-3", target: "Device-2-4" },
		{ source: "Device-2-4", target: "Device-2-5" },
		{ source: "Device-2-5", target: "Device-2-6" },
		{ source: "Device-2-6", target: "Device-2-7" },
		{ source: "Device-2-7", target: "Device-2-8" },
		{ source: "Device-2-8", target: "Device-2-1" },
		{ source: "Device-2-1", target: "Device-2-3" },
		{ source: "Device-2-3", target: "Device-2-6" },
		{ source: "Device-2-5", target: "Device-2-8" },

		// Router-3 to its child devices (7 devices)
		{ source: "Router-3", target: "Device-3-1" },
		{ source: "Router-3", target: "Device-3-2" },
		{ source: "Router-3", target: "Device-3-3" },
		{ source: "Router-3", target: "Device-3-4" },
		{ source: "Router-3", target: "Device-3-5" },
		{ source: "Router-3", target: "Device-3-6" },
		{ source: "Router-3", target: "Device-3-7" },

		// Interconnections between Router-3's child devices
		{ source: "Device-3-1", target: "Device-3-2" },
		{ source: "Device-3-2", target: "Device-3-3" },
		{ source: "Device-3-3", target: "Device-3-4" },
		{ source: "Device-3-4", target: "Device-3-5" },
		{ source: "Device-3-5", target: "Device-3-6" },
		{ source: "Device-3-6", target: "Device-3-7" },
		{ source: "Device-3-7", target: "Device-3-1" },
		{ source: "Device-3-1", target: "Device-3-3" },
		{ source: "Device-3-3", target: "Device-3-5" },
		{ source: "Device-3-5", target: "Device-3-7" },

		// Connections between Router-1 and Router-2 devices
		{ source: "Device-1-4", target: "Device-2-4" },
		{ source: "Device-1-5", target: "Device-2-5" },
	];

	return (
		<div className="col-lg-4 mb-3">
			<div className="card bg-secondary h-100">
				<div className="card-body">
					<h5 className="text-white mb-6">Network</h5>

					<div>
						<ReactECharts
							option={{
								backgroundColor: "transparent",
								series: [
									{
										type: "graph",
										layout: "none",
										symbolSize: 15,
										roam: false,
										label: {
											show: true,
											position: "bottom",
											fontSize: 8,
											color: "#bfcbdc",
										},
										edgeSymbol: ["none", "none"],
										edgeSymbolSize: [4, 10],

										data: nodeData,
										links: linkData,

										lineStyle: {
											opacity: 0.5,
											width: 1,
											color: "#4a5568",
										},
									},
								],
								tooltip: {
									show: true,
									backgroundColor: "rgba(0, 0, 0, 0.8)",
									borderColor: "#60a5fa",
									borderWidth: 1,
									textStyle: {
										color: "#fff",
										fontSize: 12,
									},
									formatter: function (params) {
										if (params.componentSubType === "graph") {
											if (params.dataType === "node") {
												return `<div style="padding: 8px 12px;"><div style="font-weight: bold; margin-bottom: 4px;">${params.name}</div><div style="font-size: 11px; color: #bfcbdc;">Type: Node</div><div style="font-size: 11px; color: #bfcbdc;">Status: Active</div></div>`;
											}
										}
										return params.name;
									},
								},
							}}
							style={{
								height: 280,
								width: "100%",
							}}
							echarts={echarts}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
